import { writeBatch, type DocumentReference, type WriteBatch } from 'firebase/firestore';
import { db } from '@/lib/firebase/config';

// Firestore batches are capped at 500 ops; auto-flush whenever we cross that line.
// Shared by the CRM rename fan-outs and delete cascades (companies/contacts/deals).
export function createBatchedWriter() {
  let batch: WriteBatch = writeBatch(db);
  let ops = 0;
  const flushers: Promise<void>[] = [];
  const flush = () => {
    if (ops === 0) return;
    flushers.push(batch.commit());
    batch = writeBatch(db);
    ops = 0;
  };
  return {
    delete(ref: DocumentReference) {
      batch.delete(ref);
      ops++;
      if (ops >= 500) flush();
    },
    update(ref: DocumentReference, data: Record<string, unknown>) {
      batch.update(ref, data);
      ops++;
      if (ops >= 500) flush();
    },
    commit: async () => {
      flush();
      await Promise.all(flushers);
    },
  };
}

// firebasestorage download URL → storage object path (for deleteObject).
// A value that isn't a firebasestorage URL is returned unchanged (already a path).
export function storagePathFromUrl(fileUrl: string): string {
  if (!fileUrl.includes('firebasestorage.googleapis.com')) return fileUrl;
  const match = fileUrl.match(/\/o\/([^?]+)/);
  return match ? decodeURIComponent(match[1]) : fileUrl;
}
